import React from 'react';
import MasterPage from 'components/MasterPage';
import { Button, Row, Container, Col, Card, Tabs, Tab } from 'react-bootstrap';
import { WidgetsOutlined, ArrowBackIos } from '@material-ui/icons';
import MyOrders from './MyOrders';
import Contracts from './Contracts';
import { Link } from 'react-router-dom';

import './style.css';

export default function () {
	return (
		<Container fluid>
      <Row className="mt-2">
        <Link to="/programs" className="link-back">
          <ArrowBackIos className="icon-title icon-back" />
          <h6 className="font-13 mt-3">Voltar</h6>
        </Link>
      </Row>
			<Row className="mt-1">
				<WidgetsOutlined className="icon-title col-auto p-0" />
				<h5 className="title-dashboard col-10 p-0">Pós Vendas</h5>
			</Row>
			<Row className="">
				<Card.Body className="card-dashboard shadow bg-white rounded m-2 col-12">
					<Row>
						<Col md="12">
							<Tabs defaultActiveKey="my-orders" className="row" id="afterSales">
								<Tab eventKey="my-orders" title="Meus Pedidos">
									<MyOrders />
								</Tab>
								<Tab eventKey="contracts" title="Contratos">
									<Contracts />
								</Tab>
							</Tabs>
						</Col>
					</Row>
				</Card.Body>
			</Row>
		</Container>
	);
}